import React from 'react'

import { alpha, styled } from '@mui/material/styles'
import Button, { ButtonProps } from '@mui/material/Button'

import colors from '@/assets/scss/_themes-vars.module.scss'

export const StyledButton = styled(Button, { shouldForwardProp: (prop) => prop !== 'active' })<{ active?: boolean }>(({ active = false }) => ({
  background: colors.indigo200,
  minWidth: 'unset',
  width: '100%',
  aspectRatio: '1/1',
  padding: '20px',
  '&:hover': {
    background: alpha(colors.indigo200, 0.75),
  },
  ...(active && {
    border: `2px solid ${colors.indigo500}`,
  }),
}))

type BackgroundEffectButtonProps = ButtonProps & {
  active?: boolean
}
export const BackgroundEffectButton = React.forwardRef(function BackgroundEffectButton(props: BackgroundEffectButtonProps, ref: React.Ref<HTMLButtonElement>) {
  const { active = false, ...rest } = props
  return <StyledButton {...props} ref={ref} />
})
